import React from "react";

/**
 * Props:
 * name
 * totalOrders
 * streak
 * lastOrderDaysAgo
 * totalSpent
 */
const CustomerLoyaltyCard = ({
  name = "Customer",
  totalOrders = 0,
  streak = 0,
  lastOrderDaysAgo = 0,
  totalSpent = 0
}) => {

  // 🔥 Loyalty score (simple version)
  const loyaltyScore = Math.min(100, Math.round(
    (streak * 10) + (totalOrders * 2)
  ));

  const radius = 45;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (loyaltyScore / 100) * circumference;

  return (
    <div className="card pl-3 pr-3 pt-3 pb-3 br18 loyalty-card">

      <div className="row align-items-center">

        {/* 🔵 LEFT: Circular progress */}
        <div className="col-4 d-flex justify-content-left pl-0">
          <div className="position-relative">

            <svg width="110" height="110">
              <circle
                cx="55"
                cy="55"
                r={radius}
                stroke="#e6e6e6"
                strokeWidth="8"
                fill="none"
              />
              <circle
                cx="55"
                cy="55"
                r={radius}
                stroke="#00b382"
                strokeWidth="8"
                fill="none"
                strokeDasharray={circumference}
                strokeDashoffset={offset}
                strokeLinecap="round"
                transform="rotate(-90 55 55)"
              />
            </svg>

            <div className="position-absolute top-50 start-50 translate-middle text-center">
              <h4 className="mb-0 font-bold">{loyaltyScore}%</h4>
              <small className="text-muted font8">Loyal</small>
            </div>

          </div>
        </div>

        {/* 🟢 RIGHT: Content */}
        <div className="col-8">

          <h5 className="mb-1 fw800">{name}</h5>

          <p className="text-muted font8 mb-2">
            <b>{totalOrders}</b> orders • Last order <b>{lastOrderDaysAgo}</b> days ago
          </p>

          {/* 🔥 Streak */}
          <div className="d-flex align-items-center gap-2 mb-2">
            <span className="badge bg-success-nw-dark">
              🔥 <b>{streak}</b> purchase streak
            </span>
          </div>

          {/* 💰 Value */}
          <p className="font8 text-muted mb-0">
            Total spent: <b>{totalSpent.toLocaleString()}</b>
          </p>

        </div>

      </div>

    </div>
  );
};

export default CustomerLoyaltyCard;